const ENDPOINT_API = "https://pill-main-prod-backend-ebaaxsuvaa-uc.a.run.app/api/"

// const ENDPOINT_API_v2 = "https://vl7vvkdhrjtx7bgv27jicumlfi0dyxto.lambda-url.us-east-2.on.aws/api/v2"


module.exports = ENDPOINT_API

